module.exports = __webpack_public_path__ + "static/media/icon-w-hillo.db684e2f.png";